import React, { useState } from 'react';
import Stepper from '../../components/client-setup/Stepper';
import { useLocation } from 'react-router-dom';
import { useGuideContext } from '../../Contexts/GuidingContext';
import useWindowWidth from '../../hooks/CalculateWindowWidh';

interface navbarProps {
  children: React.ReactNode;
  header?: JSX.Element;
  bellAndSettingsIcon?: JSX.Element;
  isAccountSetup?: boolean;
  layoutPadding?: boolean;
}

const Navbar = (props: navbarProps) => {
  const { children, header, bellAndSettingsIcon, layoutPadding, isAccountSetup } = props;
  const companyName = sessionStorage.getItem('companyName');
  const { handleNextStep, setDisabled } = useGuideContext();
  const location = useLocation();
  const windowWidth = useWindowWidth();
  const isAccountSetupPath = location.pathname.includes('/account-setup');

  const [isguide, setIsGuide] = useState(
    sessionStorage.getItem('guidance') === 'started' ? true : false
  );

  const handelguide = () => {
    setIsGuide(false);
    sessionStorage.setItem('guidance', 'completed');
    handleNextStep(0);
    setDisabled(false);
  };
  const handleContinueClick = () => {
    setDisabled(true);
    setIsGuide(false);
    sessionStorage.setItem('guidance', 'guidestarted');
    handleNextStep(1);
  };

  return (
    <div className="flex flex-col flex-1 ">
      <header className="md:ps-2 md:pe-10 ps-2 pe-2 px-2 lg:pt-4 pt-2 sticky top-0 bg-[#1E1E1E] md:py-5">
        {isguide && location.pathname === '/dashboard' ? (
          <>
            <div className="fixed inset-0 bg-black bg-opacity-50 "></div>

            <div className="bg-[#FCC737] ml-8 h-16 flex text-[#1E1E1E] items-center justify-between px-8 py-3 shadow-lg relative rounded-md z-20">
              <p className="md:text-sm text-sm font-semibold ">
                You can get connect with data source or CRM intigration follow the guide
              </p>
              <div className="flex items-center space-x-2">
                <button
                  onClick={handleContinueClick}
                  className="bg-blue-500 text-[#FFFFFF] md:text-sm text-sm px-4 py-2 rounded-md hover:bg-blue-600"
                >
                  Continue
                </button>
              </div>
              <button
                onClick={handelguide}
                className="absolute top-[-8px] right-[-8px] text-black hover:text-gray-700 bg-slate-100 rounded-full h-6 w-6"
              >
                ✖
              </button>
            </div>
          </>
        ) : (
          ''
        )}
        <div>
          <div className="flex justify-between items-center">
            {isAccountSetupPath ? (
              header
            ) : (
              <div className="hidden lg:block md:block md:ml-8 w-full">{header}</div>
            )}
            <div className="flex w-full justify-end  items-center sm:space-x-6 space-x-6">
              {(location.pathname.includes('/account-setup') || !isguide) && (
                <>
                  {bellAndSettingsIcon}

                  <div
                    className={`${
                      isAccountSetupPath ? '' : 'hidden lg:block'
                    } lg:text-lg md:text-[18px] sm:text-[15px] text-[11px]`}
                  >
                    <span className="font-normal block">Welcome!</span>
                    <span className="font-bold block overflow-hidden text-ellipsis whitespace-nowrap w-44">
                      {companyName ? companyName : ''}
                    </span>
                  </div>
                </>
              )}
            </div>
          </div>
          {isAccountSetupPath && windowWidth <= 820 && (
            <div className="block 820:hidden">
              <Stepper />
            </div>
          )}

          {!isAccountSetupPath && (
            <div className=" lg:hidden md:hidden my-4 flex justify-center">{header}</div>
          )}
        </div>
      </header>
      <main
        className={`flex flex-1 md:pb-2 md:px-5 px-2 ${isAccountSetup ? 'overflow-y-auto' : ''}  ${!layoutPadding && 'md:px-5 px-2'}`}
      >
        {children}
      </main>
    </div>
  );
};

export default Navbar;
